export var STORAGE_NAME = 'i18n';
export var initialState = {
    data: [],
    currentLang: 'ru'
};
export var cache = {
    data: 0,
    currentLang: 0
};
